// frontend/src/pages/Press.js
import '../custom.css'
import React from 'react'
import { Container, Row, Col, Button, Card } from 'react-bootstrap'

export default function Press () {
  return (
    <>
      {/* Hero */}
      <section className='full-bleed py-5 bg-primary-soft text-center'>
        <Container style={{ maxWidth: 960 }}>
          <h1 className='display-5 fw-bold mb-3'>Press & Media</h1>
          <p className='lead mb-4'>
            Download our press kit or contact us for interviews, logos, and
            product info.
          </p>
          <Button
            variant='primary'
            size='lg'
            href='/assets/press/GreatlySocial-PressKit.zip'
            download
          >
            Download Press Kit
          </Button>
        </Container>
      </section>

      {/* Latest news */}
      <section className='py-5'>
        <Container fluid='lg'>
          <h2 className='fw-bold text-center mb-5'>Latest coverage</h2>
          <Row className='g-4'>
            {[
              ['TechCrunch', 'Greatly Social raises $3M to automate cross-posting for SMBs', 'https://techcrunch.com'],
              ['Social Media Today', 'Why AI scheduling tools are marketers’ new secret weapon', 'https://www.socialmediatoday.com'],
              ['Forbes', 'The remote-first startup helping brands punch above their weight on TikTok', 'https://www.forbes.com'],
            ].map(([outlet, headline, url]) => (
              <Col md={4} key={headline}>
                <Card className='h-100 shadow-card'>
                  <Card.Body>
                    <Card.Title className='fw-semibold mb-2'>{outlet}</Card.Title>
                    <Card.Text className='text-muted'>{headline}</Card.Text>
                    <Button
                      as='a'
                      href={url}
                      target='_blank'
                      rel='noreferrer'
                      size='sm'
                      variant='outline-primary'
                    >
                      Read article
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Contact */}
      <section className='py-5 bg-light text-center'>
        <Container style={{ maxWidth: 720 }}>
          <h2 className='fw-bold mb-3'>Press inquiries</h2>
          <p className='text-muted fs-5 mb-4'>
            Email&nbsp;
            <a href='mailto:press@greatlysocial.com'>press@greatlysocial.com</a>{' '}
            and our team will respond within one business day.
          </p>
          <Button
            as='a'
            href='mailto:press@greatlysocial.com'
            variant='primary'
            size='lg'
          >
            Contact PR Team
          </Button>
        </Container>
      </section>
    </>
  )
}
